import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabbookingserviceinmumbai() {



  const cardData =
  {
    keyword: 'Corporate Cab Booking Services in Mumbai',
    heading: 'Aaryan Travels: Corporate Cab Booking Services in Mumbai',
    headingDescription: 'Aaryan Travels provides dependable Corporate Cab Booking Services in Mumbai for businesses, executives, and employees who require professional and punctual transportation across the city. Whether it’s daily office commute, airport transfers from Chhatrapati Shivaji Maharaj International Airport, client pickups, or intercity business travel to Pune, Nashik, or Surat, our fleet of sedans, SUVs, and premium vehicles ensures comfort and reliability. With trained chauffeurs, GPS-enabled cars, monthly billing options, and 24/7 availability, we deliver smooth transportation for corporate needs across Andheri, BKC, Navi Mumbai, Thane, and South Mumbai. Aaryan Travels is the trusted partner for seamless corporate cab booking services in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is Mumbai’s most iconic landmark. Originally constructed to welcome British royalty, it now stands as a symbol of history and pride. Tourists gather here for photographs and ferry rides to Elephanta Caves. At night, the monument glows beautifully under the lights. Gateway of India is Mumbai’s majestic coastal sentinel."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km-long promenade lined with palm trees and sea-facing benches. Locals come here for sunsets, street snacks, and peaceful walks. At night, the curved line of streetlights resembles a sparkling necklace. Marine Drive is Mumbai’s timeless stretch of serenity."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is an architectural marvel built in Victorian Gothic style. Its domes, stained-glass windows, and ornate carvings make it look like a royal palace. Despite its grandeur, it remains one of India’s busiest railway stations. Illuminated at night, it becomes a stunning masterpiece. CST is Mumbai’s blend of history and hustle."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most famous beaches, buzzing with vendors selling pav bhaji, bhel puri, and ice golas. Families enjoy camel rides and kite flying while watching planes fly overhead. Bollywood celebrities frequently visit this area. Juhu Beach is Mumbai’s cheerful seaside carnival."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb situated on a small islet in the Arabian Sea. Accessible via a narrow causeway, it appears to float during high tide. Devotees of all faiths come to seek blessings and enjoy soulful qawwali sessions. Haji Ali is Mumbai’s spiritual island of faith."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these rock-cut caves date back to the 5th century and are dedicated to Lord Shiva. The magnificent Trimurti sculpture is the highlight of the site. A ferry ride from Gateway of India takes visitors to the island, offering beautiful sea views. Elephanta Caves are Mumbai’s ancient marvel of stone artistry."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered temple dedicated to Lord Ganesha. The gold-adorned idol attracts thousands of devotees daily, including celebrities and politicians. Special prayers on Tuesdays draw large crowds. Siddhivinayak is Mumbai’s divine destination for blessings."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge offering breathtaking sea and skyline views while reducing travel time between South Mumbai and the suburbs. At night, its illuminated structure looks futuristic and grand. Driving across it feels exhilarating. The Sea Link is Mumbai’s symbol of modern engineering brilliance."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping street known for trendy clothes, jewelry, antiques, and quirky souvenirs. Visitors enjoy bargain shopping and café hopping at iconic spots like Café Leopold. The vibrant energy makes it a tourist favorite. Colaba Causeway is Mumbai’s colorful bazaar of charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering safaris, nature trails, and boating. The ancient Kanheri Caves inside add historical depth to the experience. Visitors often spot deer, monkeys, and exotic birds. SGNP is Mumbai’s refreshing escape into wilderness."
  }
],



  "services": [
    {
      "name": "Corporate Cab Booking Services in Mumbai",
      "description": "Corporate Cab Booking Services in Mumbai provide reliable and efficient transportation for businesses of all sizes. With trained chauffeurs, punctual service, and a variety of vehicles, companies can manage employee and client travel with ease."
    },
    {
      "name": "Mumbai Business Taxi Booking",
      "description": "Mumbai Business Taxi Booking offers quick and professional taxi services tailored for business needs. Ideal for executives, meetings, and corporate errands, it ensures timely travel and comfortable rides across Mumbai."
    },
    {
      "name": "Office Cab Hire Mumbai",
      "description": "Office Cab Hire Mumbai enables companies to organize daily staff commutes with fixed routes and schedules. The service focuses on safety, punctuality, and convenience for employees."
    },
    {
      "name": "Chauffeur Corporate Cab Mumbai",
      "description": "Chauffeur Corporate Cab Mumbai provides executive-class cab services driven by trained chauffeurs. Perfect for senior management and VIP clients, this service ensures professionalism and comfort."
    },
    {
      "name": "Staff Transportation Mumbai",
      "description": "Staff Transportation Mumbai offers dependable daily transport for company employees. With fleet management and route optimization, it ensures staff reach the workplace safely and on time."
    },
    {
      "name": "Book Corporate Cab Mumbai",
      "description": "Book Corporate Cab Mumbai allows businesses to easily schedule and manage corporate cab services online. Designed for convenience, it supports both short-term and long-term travel needs."
    },
    {
      "name": "Mumbai Corporate Car Rental",
      "description": "Mumbai Corporate Car Rental offers monthly and long-term rentals for corporate clients. Businesses can choose from a range of sedans, SUVs, and luxury cars with full maintenance and chauffeur service."
    },
    {
      "name": "Corporate Chauffeur Mumbai",
      "description": "Corporate Chauffeur Mumbai delivers premium chauffeur-driven transport for executives and corporate events. Drivers are trained in etiquette, ensuring a seamless and professional experience."
    },
    {
      "name": "Business Travel Cab Mumbai",
      "description": "Business Travel Cab Mumbai provides tailored cab solutions for frequent business travelers. It ensures reliability, comfort, and timely transportation to meetings and corporate destinations."
    },
    {
      "name": "Monthly Corporate Cab Mumbai",
      "description": "Monthly Corporate Cab Mumbai offers cost-effective monthly plans for companies needing regular transport. Ideal for daily office commutes, executive travel, and client visits."
    },
    {
      "name": "Executive Taxi Services Mumbai",
      "description": "Executive Taxi Services Mumbai cater to business leaders and professionals who prefer premium travel. With luxury vehicles and discreet chauffeurs, it reflects corporate class and comfort."
    },
    {
      "name": "Online Corporate Cab Mumbai",
      "description": "Online Corporate Cab Mumbai simplifies cab booking for businesses with an easy digital interface. Companies can manage reservations, track rides, and streamline transportation logistics efficiently."
    },
    {
      "name": "Company Transport Mumbai",
      "description": "Company Transport Mumbai provides organized transport solutions for firms requiring staff shuttles or dedicated cabs. The service supports flexible routes, shift timings, and scalable fleet options."
    },
    {
      "name": "Reliable Corporate Taxi Mumbai",
      "description": "Reliable Corporate Taxi Mumbai emphasizes consistency, punctuality, and professional service. Businesses can depend on this service for daily commutes and executive travel needs."
    },
    {
      "name": "Affordable Corporate Cab Mumbai",
      "description": "Affordable Corporate Cab Mumbai combines quality service with budget-friendly pricing. Ideal for startups and SMEs, it ensures reliable transportation without compromising on standards."
    }
  ],
  "tableData": [
    ["Corporate Cab Booking Services in Mumbai", "Mumbai Business Taxi Booking"],
    ["Office Cab Hire Mumbai", "Chauffeur Corporate Cab Mumbai"],
    ["Staff Transportation Mumbai", "Book Corporate Cab Mumbai"],
    ["Mumbai Corporate Car Rental", "Corporate Chauffeur Mumbai"],
    ["Business Travel Cab Mumbai", "Monthly Corporate Cab Mumbai"],
    ["Executive Taxi Services Mumbai", "Online Corporate Cab Mumbai"],
    ["Company Transport Mumbai", "Reliable Corporate Taxi Mumbai"],
    ["Affordable Corporate Cab Mumbai", "—"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Booking Services in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers dependable corporate cab booking services in Mumbai, perfect for managing your daily business commute efficiently."
  },
  {
    "WhyChooseheading": "Professional and Trained Chauffeurs",
    "WhyChoosedescription": "Our courteous and skilled drivers ensure prompt service, adhering to your corporate schedules without delays."
  },
  {
    "WhyChooseheading": "Well-Maintained, Air-Conditioned Vehicles",
    "WhyChoosedescription": "Travel in comfort with our fleet of clean, sanitized, and fully air-conditioned cabs designed for corporate use."
  },
  {
    "WhyChooseheading": "Drivers with Excellent Local Route Knowledge",
    "WhyChoosedescription": "Our chauffeurs are well-versed with Mumbai’s traffic patterns and routes, ensuring quick and smooth travel."
  },
  {
    "WhyChooseheading": "All-Inclusive Monthly Pricing",
    "WhyChoosedescription": "We offer transparent and fixed pricing plans that cover fuel, tolls, parking, and driver charges with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Corporate Support",
    "WhyChoosedescription": "Our round-the-clock customer service is available to address your corporate travel needs at any time."
  },
  {
    "WhyChooseheading": "Customizable Corporate Travel Plans",
    "WhyChoosedescription": "Tailor your cab booking plans based on travel frequency, preferred vehicle types, and organizational needs."
  },
  {
    "WhyChooseheading": "Exclusive Corporate Fleet Allocation",
    "WhyChoosedescription": "Enjoy priority service with vehicles reserved solely for your company's transportation requirements."
  }
]
















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab booking services in Mumbai?',
    answer: 'Yes, Aaryan Travels provides reliable and customized corporate cab booking services in Mumbai to meet your business transportation needs.',
  },
  {
    question: 'How can I book corporate cab services in Mumbai with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 corporate customer support team in Mumbai.',
  },
  {
    question: 'What types of vehicles are available for corporate cab bookings in Mumbai?',
    answer: 'Aaryan Travels offers a wide range of well-maintained sedans, SUVs, and premium vehicles suitable for corporate travel in Mumbai.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab bookings in Mumbai?',
    answer: 'Absolutely. All our drivers in Mumbai are licensed, professionally trained, and committed to punctuality and safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate bookings in Mumbai?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Mumbai and nearby business areas.',
  },
  {
    question: 'Is the corporate cab booking service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab booking services in Mumbai to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for corporate cab bookings in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for corporate cab bookings in Mumbai?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the corporate cab booking period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your booking period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Mehta',
    feedback: 'Aaryan Travels provided top-notch corporate cab booking services in Mumbai. Their punctuality and clean vehicles impressed our entire team.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'We’ve been using Aaryan Travels for our corporate cab needs in Mumbai. Exceptional service and highly professional drivers!',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const corporateCabBookingMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Booking Services in Mumbai",
  "description": "Aaryan Travels provides reliable corporate cab booking services in Mumbai, including chauffeur-driven business taxis, office cab hire, and staff transportation for companies of all sizes.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Corporate Cab Booking",
  "keywords": "Corporate Cab Booking Services in Mumbai, Mumbai Business Taxi Booking, Office Cab Hire Mumbai, Chauffeur Corporate Cab Mumbai, Staff Transportation Mumbai, Book Corporate Cab Mumbai, Mumbai Corporate Car Rental, Corporate Chauffeur Mumbai, Business Travel Cab Mumbai, Monthly Corporate Cab Mumbai, Executive Taxi Services Mumbai, Online Corporate Cab Mumbai, Company Transport Mumbai, Reliable Corporate Taxi Mumbai, Affordable Corporate Cab Mumbai"
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Booking Services in Mumbai | Reliable Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book trusted corporate cab services in Mumbai with Aaryan Travels. Chauffeur-driven office cabs, staff transportation, and business taxi bookings available."
  />
  <meta
    name="keywords"
    content="Corporate Cab Booking Services in Mumbai, Mumbai Business Taxi Booking, Office Cab Hire Mumbai, Chauffeur Corporate Cab Mumbai, Staff Transportation Mumbai, Book Corporate Cab Mumbai, Mumbai Corporate Car Rental, Corporate Chauffeur Mumbai, Business Travel Cab Mumbai, Monthly Corporate Cab Mumbai, Executive Taxi Services Mumbai, Online Corporate Cab Mumbai, Company Transport Mumbai, Reliable Corporate Taxi Mumbai, Affordable Corporate Cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateCabBookingMumbaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabbookingserviceinmumbai;